export const ROUTE_PREFIX = '';

export const TOAST_AUTO_CLOSE = false;
export const TOAST_POSITION = 'top-center';
export const ENGLISH_LANG = 'en';
export const SWEDISH_LANG = 'se';
export const ENGLISH_LANG_SHORT = 'en-US';
export const SWEDISH_LANG_SHORT = 'sv-SE';
export const LANGUAGES = [
  { value: 'sv-SE', label: 'Swedish', image: 'img/languages/swedish.svg', countryCode: 'se', locale: 'sv' },
  { value: 'en-US', label: 'English', image: 'img/languages/english.svg', countryCode: 'us', locale: 'en' },
  { value: 'de-DE', label: 'German', image: 'img/languages/german.svg', countryCode: 'de', locale: 'de' },
  { value: 'nl-NL', label: 'Dutch (Netherlands)', image: 'img/languages/dutch.svg', countryCode: 'nl', locale: 'nl' },
  { value: 'nb-NO', label: 'Norwegian', image: 'img/languages/norwegian.svg', countryCode: 'no', locale: 'no' },
  { value: 'da-DK', label: 'Danish', image: 'img/languages/danish.svg', countryCode: 'dk', locale: 'da' },
  { value: 'es-ES', label: 'Spanish', image: 'img/languages/spannish.svg', countryCode: 'es', locale: 'es' },
  { value: 'fr-FR', label: 'French', image: 'img/languages/french.svg', countryCode: 'fr', locale: 'fr' },
  { value: 'fi-FI', label: 'Finnish', image: 'img/languages/finnish.svg', countryCode: 'fi', locale: 'fi' },
  { value: 'it-IT', label: 'Italian', image: 'img/languages/italian.svg', countryCode: 'it', locale: 'it' },
  { value: 'pt-PT', label: 'Portuguese', image: 'img/languages/portuguese.svg', countryCode: 'pt', locale: 'pt' },
];
export const DOWNLOAD_TRANSPARENCY_SOFTWARE_LINK = 'https://safe-ev.org/en/transparency-software/e-mobilists/';
export const CUSTOMER_PRIVACY_NOTICE_URL = 'https://new.abb.com/privacy-notice/customer';
export const CREDIT_CARD_PAYMENT_TYPE = 'creditcard';

export const UNIT_KW = 'kW';

export const MINUTE_UNIT = 'min';

export const CREDIT_CARD_TEXT = 'credit card';

export const PREFERRED_COUNTRIES = ['se', 'dk', 'no', 'fi', 'ie', 'is', 'gb', 'ae', 'ch', 'pt'];

export const COUNTRIES = [
  { value: 'SE', label: 'Sweden', currencyCode: 'SEK' },
  { value: 'DK', label: 'Denmark', currencyCode: 'DKK' },
  { value: 'NO', label: 'Norway', currencyCode: 'NOK' },
  { value: 'FI', label: 'Finland', currencyCode: 'EUR' },
  { value: 'IE', label: 'Ireland', currencyCode: 'EUR' },
  { value: 'IS', label: 'Iceland', currencyCode: 'ISK' },
  { value: 'MX', label: 'Mexico', currencyCode: 'MXN' },
  { value: 'DE', label: 'Germany', currencyCode: 'GBP' },
  { value: 'AT', label: 'Austria', currencyCode: 'EUR' },
  { value: 'BE', label: 'Belgium', currencyCode: 'EUR' },
  { value: 'BG', label: 'Buglaria', currencyCode: 'BGN' },
  { value: 'FR', label: 'France', currencyCode: 'EUR' },
  { value: 'IT', label: 'Italy', currencyCode: 'EUR' },
  { value: 'ES', label: 'Spain', currencyCode: 'EUR' },
  { value: 'GR', label: 'Greece', currencyCode: 'EUR' },
  { value: 'HR', label: 'Croatia', currencyCode: 'HRK' },
  { value: 'EE', label: 'Estonia', currencyCode: 'EEK' },
  { value: 'PL', label: 'Poland', currencyCode: 'PLN' },
  { value: 'PT', label: 'Portugal', currencyCode: 'EUR' },
  { value: 'MU', label: 'Mauritius', currencyCode: 'MUR' },
  { value: 'NL', label: 'Netherlands', currencyCode: 'EUR' },
  { value: 'CH', label: 'Switzerland', currencyCode: 'CHF' },
  { value: 'SG', label: 'Singapore', currencyCode: 'SGD' },
  { value: 'GB', label: 'United Kingdom', currencyCode: 'GBP' },
  { value: 'USA', label: 'United States', currencyCode: 'USD' },
  { value: 'AE', label: 'United Arab Emirates', currencyCode: 'AED' },
  { value: 'CN', label: 'China', currencyCode: 'CNY' },
];

export const COUNTRIES_EXTN = [
  { code: 'se', name: 'Sweden', extn: '+46' },
  { code: 'dk', name: 'Denmark', extn: '+45' },
  { code: 'no', name: 'Norway', extn: '+47' },
  { code: 'fi', name: 'Finland', extn: '+358' },
  { code: 'is', name: 'Iceland', extn: '+354' },
  { code: 'de', name: 'Germany', extn: '+49' },
  { code: 'fr', name: 'France', extn: '+33' },
  { code: 'es', name: 'Spain', extn: '+34' },
  { code: 'ee', name: 'Estonia', extn: '+372' },
  { code: 'pl', name: 'Poland', extn: '+48' },
  { code: 'nl', name: 'Netherlands', extn: '+31' },
  { code: 'at', name: 'Austria', extn: '+43' },
  { code: 'ie', name: 'Ireland', extn: '+353' },
  { code: 'be', name: 'Belgium', extn: '+32' },
  { code: 'bg', name: 'Bulgaria', extn: '+359' },
  { code: 'cy', name: 'Cyprus', extn: '+357' },
  { code: 'lv', name: 'Latvia', extn: '+371' },
  { code: 'lu', name: 'Luxembourg', extn: '+352' },
  { code: 'sk', name: 'Slovakia', extn: '+421' },
  { code: 'si', name: 'Slovenia', extn: '+386' },
  { code: 'gr', name: 'Greece', extn: '+30' },
  { code: 'mt', name: 'Malta', extn: '+356' },
  { code: 'it', name: 'Italy', extn: '+39' },
  { code: 'hr', name: 'Croatia', extn: '+385' },
  { code: 'mx', name: 'Mexico', extn: '+52' },
  { code: 'pt', name: 'Portugal', extn: '+351' },
  { code: 'mu', name: 'Mauritius', extn: '+230' },
  { code: 'ch', name: 'Switzerland', extn: '+41' },
  { code: 'gb', name: 'United Kingdom', extn: '+44' },
  { code: 'us', name: 'United Status', extn: '+1' },
  { code: 'sg', name: 'Singapore', extn: '+65' },
  { code: 'ae', name: 'United Arab Emirates', extn: '+971' },
  { code: 'cn', name: 'China', extn: '+86' },
];

export const LOCALE_DEFAULT_CONFIG = {
  week: {
    dow: 1,
  },
};

export const REQUIRED = (resource, msg) => `${resource} ${msg}`;

export const PSP_TYPES = Object.freeze({
  APPLE_PAY: { label: 'Apple Pay', value: 'apple' },
  GOOGLE_PAY: { label: 'Google Pay', value: 'google' },
  GITO: { label: 'Gito', value: 'gito' },
  VOLVO: { label: 'Volvo', value: 'volvo' },
  BOSCH: { label: 'Bosch', value: 'bosch' },
  HUBJECT: { label: 'Hubject', value: 'hubject' },
  EASYPARK: { label: 'Easy park', value: 'easypark' },
  SWISH: { label: 'Swish', value: 'swish' },
  STRIPE: { label: 'Stripe', value: 'stripe' },
  CREDITCARD: { label: 'Card', value: 'creditcard' },
  PLANETPAYMENT: { label: 'Planet payment', value: 'planetpayment' },
  BLUECODE: { label: 'Bluecode', value: 'bluecode' },
  ACCESSTOKEN: { label: 'Access token', value: 'accesstoken' },
  BINANCE: { label: 'Binance', value: 'binance' },
  VIPPS: { label: 'Vipps', value: 'vipps' },
  MOBILEPAY: { label: 'Mobile pay', value: 'mobilepay' },
  NORTHE: { label: 'Northe', value: 'northe' },
  ADYEN: { label: 'Adyen', value: 'adyen' },
  TWINT: { label: 'Twint', value: 'twint' },
});

export const DUMMY_IMG_URL = 'img/dummy.png';
